/*
 * @Author: sunhui04
 * @Date: 2021-08-20 14:53:55
 */

var Perf = {
    logQueue : [],
    lastTime : null,
    timer :  null,
    initData: {
        "category": "prism-report-knb",
        "env": {
            "version": "1.0.0"  // 全局通用维度
        },
    },
    sendQueue: function sendQueue(logQueue, fail) {
        var this$1 = this;

        var logs = [];
        logQueue.forEach(function (item) {
            // 采样
            if(!this$1.getRate()) return;
            logs.push({
                "type": "titans-bridge-timing", // 指标命名
                "value": item.execTime,  // 指标数值
                "tags": {
                    "bridgeName": item.bridgeName,  // 指标维度
                    "url": location && (location.origin + location.pathname),
                    "stage": item.stage
                }
            })
        })
        if(logs.length === 0) return;
        var reportData = Object.assign({}, {
            "logs": logs
        }, this.initData)
        this.lastTime = Date.now();
        this.ajax(reportData, fail);
    },
    ajax: function ajax(reportData, fail) {
        var xhr = new XMLHttpRequest();
        xhr.onerror = xhr.ontimeout = function () {
            fail && fail();
        };
        xhr.open("POST","https://prism-report-knb.dreport.meituan.net",true);
        reportData = JSON.stringify(reportData);
        xhr.send(reportData);
    },
    retry: function retry(data) {
        this.ajax(data);
    },
    sendTimeoutPerf: function sendTimeoutPerf(option) {
        var this$1 = this;

        // 桥调用超时： 不采样，直接上报
        setTimeout(function () {
            var reportData = Object.assign({}, {
                "logs": [{
                    "type": "knb-web-timeout", // 指标命名
                    "value": 1,  // 指标数值
                    "tags": {
                        "bridgeName": option.bridgeName,  // 指标维度
                        "url": location && (location.origin + location.pathname)
                    }
                }]
            }, this$1.initData)
            this$1.ajax(reportData, this$1.retry.bind(this$1, reportData));
        }, 0);
    },
    sendPerf: function sendPerf(option) {
        var this$1 = this;

        setTimeout(function () {
            this$1.logQueue.push(option);
            !this$1.lastTime && (this$1.lastTime = Date.now());
            clearTimeout(this$1.timer);
            if(this$1.logQueue.length >= 5 || (Date.now() - this$1.lastTime >= 5000)) {
                this$1.sendQueue(this$1.logQueue, this$1.retry.bind(this$1, this$1.logQueue));
                this$1.logQueue = [];
            } else {
                this$1.timer = setTimeout(function () {
                    this$1.sendQueue(this$1.logQueue, this$1.retry.bind(this$1, this$1.logQueue));
                    this$1.logQueue = [];
                }, 5000);
            }
        }, 0);
    },
    getRate: function getRate() {
        // perf要求控制采样率，10%
        var random = Math.floor(Math.random()*10);
        if(random === 9) {
            return true;
        }
        return false;
    }
}


module.exports = Perf;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/common/perf.js
// module id = 510
// module chunks = 0